import { create } from 'zustand'

const DEFAULT_STATE = {
  searchQuery: '',
  channelFilter: 'all',
  listFilter: 'all',
  staffFilter: 'all',
  selectedContactId: null,
  selectedChannel: null,
  mobileView: 'list',
  mobileContactId: null,
  mobileSelectedChannel: null,
}

const useInboxUiStore = create((set) => ({
  byTenant: {},
  patchTenant: (tenantId, patch) => {
    if (!tenantId) return
    set((state) => ({
      byTenant: {
        ...state.byTenant,
        [tenantId]: {
          ...DEFAULT_STATE,
          ...state.byTenant[tenantId],
          ...patch,
        },
      },
    }))
  },
}))

export { DEFAULT_STATE as DEFAULT_INBOX_UI_STATE }
export default useInboxUiStore

